import { SortOption } from './sort.type';

export const SORT_OPTION_DEFAULT: SortOption = '-created_at';
export const PAGE_SIZE_DEFAULT = 24;
